package de.oevbs.kunde.kundenportal2.services.account.delete

import de.oevbs.kunde.kundenportal2.PortalMessages
import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.account.DeleteAccount
import de.oevbs.kunde.kundenportal2.services.account.AccountClient
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import dev.fritz2.core.Handler
import dev.fritz2.core.invoke
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.remote.btoa
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job

class DeleteStore(job: Job) : ValidatingStore<DeleteAccount, Unit, ComponentValidationMessage>(
    initialData = DeleteAccount(),
    validation = DeleteAccount.validation,
    metadataDefault = Unit,
    validateAfterUpdate = false,
    job = job
) {

    val submitDeleteAccountRequest: Handler<Unit> = handle { userData ->
        GlobalServiceMessagesStore.clear()

        if (!validate(userData).valid) {
            return@handle userData
        }

        val success = globalSubmitTracker.track {
            deleteAccount(userData)
        }

        if (success) {
            GlobalServiceMessagesStore.addSticky(PortalMessages.accountDeleted)
            PortalSession.portalLogout()
            DeleteAccount()
        } else userData
    }

    private suspend fun deleteAccount(userData: DeleteAccount): Boolean {
        tryCatchAndHandleErrors("Löschen des Accounts") {
            AccountClient().deleteAccount(btoa(userData.currentPassword))
        } ?: return false

        return true
    }
}